import { Box, Button, Chip, TextField, Typography } from '@mui/material';
import { Files, Paperclip } from '@phosphor-icons/react';
import { INode } from '../../Context/FormBuilderContext';

interface InputWidgetProps {
  node: INode;
}

export function InputWidget({ node }: InputWidgetProps) {
  const styles = node?.data?.styles;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: '8px',
      }}
    >
      {node?.data?.requiredField && (
        <Chip
          label="Required"
          size="small"
          style={{ width: 'fit-content', marginBottom: '4px' }}
        />
      )}

      {node?.data?.title && (
        <Typography
          style={{
            fontWeight: styles?.title?.isBold ? '700' : '400',
            fontStyle: styles?.title?.isItalic ? 'italic' : 'normal',
            textDecoration: styles?.title?.isUnderlined ? 'underline' : 'none',
            textAlign: styles?.title?.textAlign || 'left',
            fontFamily: styles?.title?.fontFamily || 'Roboto, sans-serif',
            fontSize: `${styles?.title?.fontSize || 16}px`,
            color: styles?.title?.color || '#1F2937',
            width: '100%',
            letterSpacing: '0.5px',
          }}
        >
          {node?.data?.title}
        </Typography>
      )}

      {node?.data?.subtitle && (
        <Typography
          style={{
            color: styles?.subtitle?.color || '#475467',
            fontFamily: styles?.subtitle?.fontFamily || 'Roboto, sans-serif',
            fontSize: `${(styles?.subtitle?.fontSize || 16) * 0.875}px`,
            fontWeight: styles?.subtitle?.isBold ? '600' : '400',
            fontStyle: styles?.subtitle?.isItalic ? 'italic' : 'normal',
            textDecoration: styles?.subtitle?.isUnderlined
              ? 'underline'
              : 'none',
            textAlign: styles?.subtitle?.textAlign || 'left',
            width: '100%',
            letterSpacing: '0.5px',
          }}
        >
          {node?.data?.subtitle}
        </Typography>
      )}

      <Box
        sx={{
          width: '100%',
          border: '1px solid #E4E7EC',
          borderRadius: '8px',
          padding: '16px',
          backgroundColor: '#FFFFFF',
          boxSizing: 'border-box',
          transition: 'all 0.2s ease-in-out',
          position: 'relative',
          height: '100%',
          cursor:
            node?.data?.fieldType === 'upload'
              ? 'default'
              : node?.data?.fieldType === 'data'
              ? 'text'
              : 'text',
          '&:hover': {
            borderColor: '#D1D5DB',
          },
        }}
      >
        <TextField
          fullWidth
          variant="standard"
          placeholder={node?.data?.placeholder || 'Type your answer here...'}
          multiline
          rows={node?.data?.minRows || 3}
          disabled={node?.data?.fieldType === 'upload'}
          sx={{
            '& .MuiInputBase-root': {
              border: 'none',
              paddingBottom: '28px',
              height: '100%',
              minHeight: `${(node?.data?.minRows || 3) * 24 + 28}px`,
              '&:before': {
                borderBottom: 'none',
              },
              '&:after': {
                borderBottom: 'none',
              },
              '&:hover:not(.Mui-disabled):before': {
                borderBottom: 'none',
              },
            },
            '& .MuiInputBase-input': {
              fontSize: '16px',
              lineHeight: '1.5',
              color: node?.data?.fieldType === 'upload' ? '#9CA3AF' : '#1F2937',
              '&::placeholder': {
                color: '#9CA3AF',
                opacity: 1,
              },
            },
            '& .MuiInputBase-input.Mui-disabled': {
              WebkitTextFillColor: '#9CA3AF',
            },
          }}
        />

        {(node?.data?.fieldType === 'both' ||
          node?.data?.fieldType === 'upload') && (
          <Box
            sx={{
              position: 'absolute',
              bottom: '8px',
              left: '8px',
              right: '8px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            }}
          >
            <Button
              startIcon={<Paperclip size={16} />}
              sx={{
                minWidth: 'auto',
                minHeight: '27px',
                height: '27px',
                padding: '4px 8px',
                fontSize: '12px',
                textTransform: 'none',
                color: '#6B7280',
                backgroundColor: 'transparent',
                border: '1px solid #E5E7EB',
                borderRadius: '4px',
                '&:hover': {
                  backgroundColor: '#F9FAFB',
                  borderColor: '#D1D5DB',
                },
              }}
            >
              Attach file
            </Button>

            <Button
              startIcon={<Files size={16} />}
              sx={{
                minWidth: 'auto',
                minHeight: '27px',
                height: '27px',
                padding: '4px 8px',
                fontSize: '12px',
                textTransform: 'none',
                color: '#6B7280',
                backgroundColor: 'transparent',
                border: '1px solid #E5E7EB',
                borderRadius: '4px',
                position: 'relative',
                '&:hover': {
                  backgroundColor: '#F9FAFB',
                  borderColor: '#D1D5DB',
                },
              }}
            >
              Files (0)
            </Button>
          </Box>
        )}
      </Box>
    </div>
  );
}
